import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "./motion";

const STATS = [
  { to: 3, prefix: "≤", suffix: " min", label: "do HTML da IA até o link no ar" },
  { to: 100, suffix: "%", label: "das páginas com SSL + CDN inclusos" },
  { to: 0, suffix: "", label: "linhas de código pra publicar", fixed: "0" },
  { to: 15, suffix: "", label: "domínios próprios no plano Agência" },
];

const Counter = ({ to, prefix = "", suffix = "", fixed }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-20% 0px" });
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const c = animate(0, to, { duration: 1.8, ease: [0.22, 1, 0.36, 1], onUpdate: (x) => setV(Math.round(x)) });
    return () => c.stop();
  }, [inView, to]);
  return <span ref={ref}>{prefix}{fixed ?? v}{suffix}</span>;
};

export const Stats = () => (
  <section data-testid="stats-section" className="px-6 py-10">
    <div className="mx-auto max-w-7xl rounded-[2rem] bg-[var(--blue)] text-white px-8 sm:px-14 py-16 sm:py-20 relative overflow-hidden">
      <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-white/10 blur-3xl" />
      <div className="absolute -left-16 -bottom-24 h-72 w-72 rounded-full bg-[var(--orange)]/40 blur-3xl" />
      <div className="relative grid md:grid-cols-4 gap-10 divide-y md:divide-y-0 md:divide-x divide-white/15">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1} data-testid={`stat-${i + 1}`} className="md:pl-8 first:pl-0 pt-8 md:pt-0 first:pt-0">
            <div className="font-display font-bold tracking-tight text-5xl sm:text-6xl leading-none"><Counter {...s} /></div>
            <div className="mt-4 text-sm text-blue-100 leading-snug max-w-[200px]">{s.label}</div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
